import { ScrollSection } from "@/components/main-page/ScrollSection";

const BELIEFS = [
  {
    title: "Compliance is architecture, not a feature",
    text: "Most AI companies treat compliance as a checkbox. They build the product first and bolt on audit trails later. We do the opposite. Compliance requirements shape our architecture from day one. If it can't be audited, it doesn't ship.",
  },
  {
    title: "Humans stay in the loop",
    text: "We don't believe in fully autonomous AI for regulated industries. Every COSX agent output passes through human review before it reaches a client. This isn't a temporary limitation. It's a design principle. AI handles volume. Humans handle judgment.",
  },
  {
    title: "Build once, deploy everywhere",
    text: "Every new vertical we enter inherits the platform's compliance, governance, and infrastructure on day one. We don't rebuild for each industry. This is why our first agent took months and our second took weeks. The platform is the product.",
  },
  {
    title: "Own the transformation",
    text: "We don't sell software to firms and hope they adopt it. We acquire firms, deploy our agents inside their operations, and transform the economics. When you own the firm and the platform, the incentives are fully aligned.",
  },
];

export function BeliefsSection() {
  return (
    <ScrollSection id="principles" title="What we believe" compact>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {BELIEFS.map((belief) => (
          <div
            key={belief.title}
            className="border border-[var(--color-border)] p-6 md:p-8"
          >
            <h3 className="text-sm font-[family-name:var(--font-mono)] font-medium mb-3">
              {belief.title}
            </h3>
            <p className="text-sm text-[var(--color-fg-secondary)] leading-relaxed">
              {belief.text}
            </p>
          </div>
        ))}
      </div>
    </ScrollSection>
  );
}
